import {
  PublicEventDetailsResponse,
  PublicExhibitionItem,
} from '@hubs101/booking-api-skd-client/lib/types';
import { Image, Text, View } from '@react-pdf/renderer';

import { getImageSrc } from '@utils/fn';
import { replaceWithComponent } from '@utils/htmlParser';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { globalStyles } from '../../styles';
import { styles as moderatorsStyles } from '../Moderators/styles';
import { styles } from './styles';

interface BusinessPartnerProps {
  event: PublicEventDetailsResponse;
  exhibitions: PublicExhibitionItem[];
}

const BusinessPartner = ({ event, exhibitions }: BusinessPartnerProps) => {
  const { t } = useTranslation();

  function extractAndRemoveUrl(htmlString: string) {
    // Regex to match the <a> tag with href and capture the URL
    const urlRegex = /<a[^>]+href="([^"]+)"[^>]*>.*?<\/a><\/p>/i;

    // Extract the URL
    const match = htmlString.match(urlRegex);
    const url = match ? match[1] : null;

    // Remove the entire <p> element that contains the URL
    const cleanedString = htmlString.replace(
      /<p><a[^>]+href="[^"]+"[^>]*>.*?<\/a><\/p>/i,
      ''
    );

    return { url, cleanedString };
  }

  const businessPartnerExhibitions = useMemo(
    () =>
      exhibitions?.map(exhibition => {
        const { url, cleanedString } = extractAndRemoveUrl(
          exhibition?.company?.about
        );

        return {
          id: exhibition?.id,
          companyLogo: getImageSrc(exhibition?.company?.logo),
          name: exhibition?.name,
          about: cleanedString,
          website: exhibition?.contact?.website1 || url,
        };
      }),
    [exhibitions]
  );
  return (
    <View style={globalStyles.body}>
      <Text
        style={{
          ...globalStyles.mediumTitle,
          color: event?.design?.themeColor,
        }}
      >
        {t('business-partner')}
      </Text>
      <View
        style={{
          ...globalStyles.lineBar,
          borderColor: event?.design?.themeColor ?? 'black',
        }}
      />
      <View style={styles.exhibitionWrapper}>
        {businessPartnerExhibitions?.map(exhibition => (
          <View style={styles.exhibitionItem} wrap={false} key={exhibition.id}>
            <View style={styles.headerRow}>
              <View style={styles.imageWrapper}>
                <Image style={styles.logo} src={exhibition.companyLogo} />
              </View>
              <View style={styles.titleWrapper}>
                <Text style={moderatorsStyles.speakerCompanyName}>
                  {exhibition.name}
                </Text>
              </View>
            </View>

            <Text style={styles.aboutText}>
              {replaceWithComponent(exhibition.about ?? '', true)}
            </Text>

            <Text style={moderatorsStyles.websiteURLText}>
              {exhibition.website?.length ? exhibition.website : ''}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
};

export default BusinessPartner;
